import React from "react";
import CustomTabsGrid from "components/CustomTabs/CustomTabsGrid.js";
import Baocaothongkephuongtien from "components/Baocao/Dangkiem/Baocaothongkephuongtien.js";
export default function BCdangkiem() {
  return (
    <div>
      <CustomTabsGrid
        headerColor="primary"
        tabs={[
          {
            tabName: "Thống kê phương tiện đăng kiểm",
            tabContent: <Baocaothongkephuongtien />,
          },
        ]}
      />
    </div>
  );
}
